import { useEffect, useState } from 'react'
import { isEnteringViewport } from '../utils/checkElementInViewport'

const useFloatingNavVisibility = () => {
	const [isFloatingNavShown, setIsFloatingNavShown] = useState(true)

	useEffect(() => {
		const footer = document.querySelector('.footer-container')

		const handleScroll = () => {
			if (isEnteringViewport(footer)) {
				setIsFloatingNavShown(false)
			} else {
				setIsFloatingNavShown(true)
			}
		}

		document.addEventListener('scroll', handleScroll, { passive: true })
		return () => {
			document.removeEventListener('scroll', handleScroll)
		}
	}, [])

	return isFloatingNavShown
}

export default useFloatingNavVisibility
